import { Designer } from "@brg/api";

export const deduplicate = (array: any[]) => {
    return Array.from(new Set(array))
}


export const mergeArraysBySubscribedId = (array1: Designer<'Global'>[], array2: any[], fieldsToMerge = ['visibility', 'status'], defaultValues = {}) => {

  const result = [...array1];

  return result.map(item => {
      const match = array2.find(item2 => item2.targetId === item.accountId);
      if (match) {
          const mergedFields = {};
          fieldsToMerge.forEach(field => {
              // @ts-ignore
              mergedFields[field] = match[field] !== undefined ? match[field] : (defaultValues[field] || null);
          });
          return { ...item, ...mergedFields };
      }

      return { ...item, ...defaultValues };
  });
}

export const getNonNullParam = (obj: any) => {
    let filteredObj: Record<string, any> = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (obj[key] !== null && obj[key] !== undefined) {
                filteredObj[key] = obj[key];
            }
        }
    }

    return Object.keys(filteredObj).length > 0 ? filteredObj : {};
    
}import { Designer } from "@brg/api";

export const deduplicate = (array: any[]) => {
    return Array.from(new Set(array))
}


export const mergeArraysBySubscribedId = (array1: Designer<'Global'>[], array2: any[], fieldsToMerge = ['visibility', 'status'], defaultValues = {}) => {

  const result = [...array1];

  return result.map(item => {
      const match = array2.find(item2 => item2.targetId === item.accountId);
      if (match) {
          const mergedFields = {};
          fieldsToMerge.forEach(field => {
              // @ts-ignore
              mergedFields[field] = match[field] !== undefined ? match[field] : (defaultValues[field] || null);
          });
          return { ...item, ...mergedFields };
      }

      return { ...item, ...defaultValues };
  });
}

export const getNonNullParam = (obj: any) => {
    let filteredObj: Record<string, any> = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (obj[key] !== null && obj[key] !== undefined) {
                filteredObj[key] = obj[key];
            }
        }
    }

    return Object.keys(filteredObj).length > 0 ? filteredObj : {};
    
}